import { questions, questionsOrder } from './data/questions'
import answers from './data/answers'

const makeAnswer = (q, chat) => {
  const answer = chat.answers[q]
  const {type} = questions[q]
  switch(type) {
    case 'button':
      return answers[answer].title
    case 'input':
      return answer
    case 'multiple':
      return answer.map(a => answers[a].title).join(', ')
    default:
      return 'Непонятный тип'
  }
}

export const getAnswerValue = (question, answer) => {
  const {type} = questions[question]
  switch(type) {
    case 'button':
      return answers[answer].value
    case 'input':
      return answer
    case 'multiple':
      return answer.map(a => answers[a].value).join(', ')
    default:
      return 'Непонятный тип'
  }
}

export const listChat = ({chat}) => (
  chat.order.map(q => ({
    id: q,
    question: questions[q].text,
    answer: makeAnswer(q, chat)
  }))
)

const withAnswers = (question, q) => ({
  ...question,
  id: q,
  answers: question.answers ? question.answers.map(a => ({...answers[a], id: a})) : null
})

export const currentQuestion = ({chat}) => {
  const isDone = chat.question === Object.getOwnPropertyNames(questions).length
  if (!isDone) {
    const q = questionsOrder[chat.question]
    return withAnswers(questions[q], q)
  }

  return {id: 'result'}
}

const answerValue = (chat, q) => {
  if (typeof chat.answers[q] === 'undefined') {
    return ''
  }

  const answer = chat.answers[q]
  const {type} = questions[q]

  switch(type) {
    case 'button':
      return answers[answer].value
    case 'input':
      return answer
    case 'multiple':
      return answer.map(a => answers[a].title).join(', ')
    default:
      return 'Непонятный тип'
  }
}

export const makeResults = ({chat}) => ([
  'Фантастика! Теперь у меня есть все, чтобы помочь вам. Проверьте ваши данные:',
  [
    ['Город/Район', answerValue(chat, 'location')],
    ['Покупка недвижимости', answerValue(chat, 'term')],
    ['Комнат в квартире', answerValue(chat, 'area')],
    ['Бюджет', answerValue(chat, 'budget')],
    ['Ипотека', answerValue(chat, 'mortgage')],
    ['Имя', answerValue(chat, 'name')],
    ['Email', answerValue(chat, 'email')],
    ['Телефон', answerValue(chat, 'phone')]
  ],
  'Эту информацию я передам нашему лучшему менеджеру. Очень скоро мы вам перезвоним.',
  'Если видите ошибку, обновите страницу и поговорите со мной еще раз. :upside_down:'
])

export const chatComplete = ({chat}) => chat.question === Object.getOwnPropertyNames(questions).length



// WEBPACK FOOTER //
// ./selectors/chat.js